module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/terms/term-dialog/term-dialog.component.css
// module id = ./src/app/components/terms/term-dialog/term-dialog.component.css
// module chunks = main